<template>
  <div class="login" v-if="loginType == '' ">
    <div v-if="schoolCode == '10541'" class="log-title1">
      <span class='log-titlechildren'>湖南中医药大学教务管理系统</span>
    </div>

    <p v-else-if="schoolCode == '12343'" class="log-title">教务查询</p>
    <p v-else-if="schoolCode == '12845'" class="log-title"></p>
    <p v-else-if="schoolCode == '13988'" class="log-title"></p>
    <p v-else class="log-title">登录</p>
    <div :class="schoolCode=='13988'?'log-logo_13988':'log-logo'">
      <img v-if="schoolCode == '12343'" src="../../static/logo/logo_12343.png" alt="" />
      <img v-else-if="schoolCode == '10541'" src="../../static/logo/logo_10541.png" alt="" />
      <img v-else-if="schoolCode == '10045'" src="../../static/logo/logo_10045.jpg" alt="" />
      <img v-else-if="schoolCode == '13988'" src="../../static/logo/logo_13988_new.png" alt="" />
      <img style="width:85%" v-else-if="schoolCode == '12845'" src="../../static/logo/logo_12845.jpg" alt="" />
      <span class="bzy_class" v-else-if="schoolCode == '13899'" >
        <h4>北京中医药大学东方学院</h4>
        <h4>教务系统</h4>
        <img src="../../static/logo/logo_13899.jpg" alt="" />
      </span>
      <img v-else src="../../static/img/logo.png" alt="" />
      <p v-if="schoolCode == '13988'">教务一体化系统手机端</p>
    </div>

    <form action="">
      <div class="log-input">
        <p>学号/工号</p>
        <div :class="isFocus ? 'input-active' : 'input-item'">
          <input
            type="text"
            placeholder="请输入学号/工号"
            v-model.trim="account"
            autocomplete="user"
            @focus="lineChange(0)"
            @keyup.enter="loginSubmit()"
          />
          <i class="delete-icon" v-if="account" @click="deleteTap(0)"></i>
        </div>
      </div>
      <div class="log-input">
        <p>密码</p>
        <div :class="isFocus1 ? 'input-active' : 'input-item  '">
          <input
            type="password"
            placeholder="请输入密码"
            v-model="password"
            autocomplete="psw"
            @focus="lineChange(1)"
            @keyup.enter="loginSubmit()"
          />
          <i class="delete-icon" v-if="password" @click="deleteTap(1)"></i>
        </div>
      </div>
      <div class="log-input" v-if="captchaOpen">
      <p>验证码</p>
      <div :class="'input-item'">
        <input type="text" placeholder="请输入验证码" v-model.trim="captchaData" style="">
        <span class="imgclass"><img :src="captcha" alt="" @click="resetCode()" /></span>
      </div>
    </div>
    </form>
    <div class="log-btn">
      <button @click="loginSubmit()" style="background-color: #0189f9;" v-if="schoolCode == '13988'">登录</button>
      <button @click="loginSubmit()" v-else>登录</button>
      <p style="color:#AAAAAA;margin-top: 20px" @click="retrievePwd()" v-if="needRetrievePwd=='1'">忘记密码?</p>
    </div>
  </div>
</template>

<script>
import { Api } from "../utils/axios";
import service from '../utils/request'
import { from } from "responselike";
import Utils from "../utils/util";
export default {
  data() {
    return {
      account: "",
      publicPath: process.env.BASE_URL,
      password: "",
      // logo: require('../../static/img/logo.png'),
      isFocus: false,
      isFocus1: false,
      schoolcode: "",
      schoolCode: "",
      captcha:"",
      captchaData:"",
      codeVal:"",
      captchaOpen:false,
      needRetrievePwd:"0",
      loginType: window.__config__.LOGIN_TYPE
    };
  },
  beforeCreate() {
    sessionStorage.setItem("menuSave", 0);
    sessionStorage.setItem("ifSelect", 0);
  },
  created() {
    if("1" ==  this.loginType){
      window.location.href = service.defaults.baseURL+"/loginSso"
    }
    
    let sccd = sessionStorage.getItem("schoolCode");
    if(!sccd||sccd==''){
       this.getSchoolCode();
    }else{
      this.schoolCode = sccd;
      if(this.schoolCode=='12845'){
        this.captchaOpen = true;
        this.getCode();
    }
    }
    sessionStorage.setItem("isNeedLogout", 1);
    //单点登录判断
    sessionStorage.removeItem("casLogin");
    sessionStorage.removeItem("isWechat");
    if (!sessionStorage.getItem("casLogin")) {
      if (
        sessionStorage.getItem("isConfig") &&
        sessionStorage.getItem("isConfig") == 1
      ) {
      } else {
        // this.getSelectApi(sessionStorage.getItem('schoolCode'))
      }
    }
      this.getRetrievePwdData()
  },
  methods: {
    async getSelectApi(e) {
      const params = {
        xx0101id: e,
        key: "qzkj"
      };
      const res = await Api.getSelectApi(params);
      if (res.data) {
        sessionStorage.setItem("SelectUrl", res.data.courseurl);
        if (process.env.NODE_ENV === "production") {
          service.defaults.baseURL = res.data.schoolurl;
          console.log(service.defaults.baseURL);
        }
      }
    },
    async ss() {
      let keystr = this.getPwdKey();
        const params = {
           'parmKeid':keystr
        }
      const code = await Api.getSchoolCode();
      sessionStorage.setItem("schoolCode", code.data.schoolcode);
      this.schoolcode = code.data.schoolcode;
    },
    async login() {
      let params = {
        userNo: this.account,
        pwd:window.btoa(Utils.encrypt(this.password)),
        encode: "1",
        captchaData:this.captchaData,
        codeVal:this.codeVal
      };
      const res = await Api.userLoginApi(params);
      if (res.code == 1&&res.data&&res.data.token) {
        sessionStorage.setItem("Identity", res.data.userType);
        sessionStorage.setItem("Token", res.data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(res.data));
        if(this.account==this.password){
            this.$router.push("/updatePaw");
            return false
        }
        this.$toast.success(res.Msg);
        // 实验室扫码
        if (this.$route.query.jx0601id && this.$route.query.gwbh) {
          sessionStorage.setItem("jx0601id", this.$route.query.jx0601id);
          this.$router.push({
            path: "/laboratory/repair",
            query: {
              jx0601id: this.$route.query.jx0601id,
              gwbh: this.$route.query.gwbh
            }
          });
        } else if (this.$route.query.jx0601id) {
          sessionStorage.setItem("jx0601id", this.$route.query.jx0601id);
          this.$router.push({
            path: "/laboratory/index",
            query: {
              jx0601id: this.$route.query.jx0601id
            }
          });
        } else {
          console.log(this.schoolCode);
          if(this.schoolCode=='10013'){
             this.$router.push("/new/Home_10013");
          }else{
             this.$router.push("/homeIndex");
          }

         
        }
      }else{
        this.$toast.fail(res.Msg);
      }
    },
    loginSubmit() {
      if (this.account == "" || this.password == "") {
        this.$toast.fail("请填写账号或密码");
      } else {
        if(this.captchaOpen){
          if(this.captchaData==""){
            this.$toast.fail("请输入验证码");
            return;
          }
          // else if(this.captchaData!=this.codeVal){
          //   this.$toast.fail("验证码不正确");
          //   return;
          // }
        }
        this.login();
      }
    },
    deleteTap(val) {
      if (val == 0) {
        this.account = "";
      } else {
        this.password = "";
      }
    },
    getPwdKey(){
      let monthVal = new Date().getMonth();
      if(monthVal>=9){
        monthVal = monthVal+1;
      }else{
        monthVal = "0"+(monthVal+1);
      }
      let dateVal = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
      let keyArr = [];
      keyArr.push(new Date().getFullYear());
      keyArr.push(monthVal);
      keyArr.push(dateVal);
      let strpwd = "";
      let pwdPosion = "";
      for(let i=0;i<3;i++){
        let rndNb = Math.ceil(Math.random()*9);
        pwdPosion+=rndNb;
        for(let k=0;k<rndNb*1;k++){
          strpwd+=Math.ceil(Math.random()*9);
        }
        strpwd+=keyArr[i];
      }
      strpwd+=pwdPosion;
      return strpwd;
    },
    async getSchoolCode() {
      let keyStr = this.getPwdKey();
      const params = {
        'parmKeid' :keyStr
      };
      const res = await Api.getSchoolCode(params);
      sessionStorage.setItem("schoolCode", res.data.schoolcode);
      this.schoolCode = sessionStorage.getItem("schoolCode");
      if(this.schoolCode=='12845'){
        this.captchaOpen = true;
        this.getCode();
    }
    },
    lineChange(res) {
      if (res == 0) {
        this.isFocus = true;
        this.isFocus1 = false;
      } else {
        this.isFocus1 = true;
        this.isFocus = false;
      }
    },
    async getCode(){
      const res = await Api.getcaptchaCode();
      if(res&&res.code=='1'){
        this.captcha = res.data;
        this.codeVal = res.codeval;
      }
    },
    resetCode(){
      this.getCode();
    },
    retrievePwd(){
        this.$router.push("/retrievePwd");
    },
    async getRetrievePwdData() {
        let params = {
            type:"cx",
        };
        const res = await Api.getRetrievePwdData(params);
        if (res.needRetrievePwd != undefined && res.needRetrievePwd != "") {
            this.needRetrievePwd = res.needRetrievePwd
            if(res.captcha=="1"){
                this.captchaOpen = true;
                this.getCode();
            }
        }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.login {
  .bzy_class{
    font-family:'aril';
    font-size: .1625rem;
    line-height: .275rem;
  }
  .log-title1{
    display: flex;
    width: 100%;
    align-items: center;
      justify-content: center;
    .log-titlechildren{
      display: block;
      font-size:1.3375rem;
      color: @attendance-color-1;
      font-weight: 550;
    }
  }
  .log-title {
    font-size:1.3375rem;
    color: @attendance-color-1;
    font-weight: 550;
    margin: -20px 36px 27px;
  }
  .log-logo {
    text-align: center;
    padding: 28px 0 49px;
    img {
      width: 77px;
      height: 77px;
    }
  }
  .log-input {
    padding: 0 36px;
    p {
      color: @attendance-color-2;
      margin-bottom: 11px;
    }
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      justify-content: space-between;
      margin-bottom: 24px;
      > input {
        font-size: 24px;
        color: @attendance-color-1;
        width: 90%;
        padding: 0 4px;
        background-color: @attendance-color-3;
        &::placeholder {
          font-size: 20px;
        }
      }
      i {
        background: url(../../static/img/delete.png) no-repeat center;
        width: 16px;
        height: 16px;
        background-size: 16px 16px;
      }
    }
    .input-item {
      border-bottom: 1px solid @attendance-border-color-3;
    }
    .input-active {
      border-bottom: 1px solid @attendance-color-2;
    }
  }
  .log-btn {
    text-align: center;
    padding: 0 1.25rem;
    button {
      background-color: @attendance-background-color-1;
      padding: 11px 0;
      width: 100%;
      color: @attendance-color-3;
      border-radius: 3px;
      margin-top: 33px;
    }
  }
  .imgclass{
    height: 30px;
    margin-left: 20px;
  }
}
.log-logo_13988{
  text-align: center;
  padding: 0px 0 49px;
  background-image:url("../../static/logo/bj_13988.png");
  background-size: 100% auto;
  background-repeat:no-repeat;
  min-height: 195px;
  img{
    width: 80%;
    margin-left: 0;
    left: 10%;
    top:35px;
    z-index: 999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue